__turbopack_context__.v({
  "map": "ShopsMap-module-scss-module__J6k8Ba__map",
  "root": "ShopsMap-module-scss-module__J6k8Ba__root",
});
